
import "./App.css";
import Navbar from "./Component/Navbar";

import AllRoute from "./Pages/AllRoute";
import { Box, VStack } from "@chakra-ui/react";
import Footer from "./Component/Footer";
import Contact from "./Pages/Contact";

import Skills from "./Pages/Skills";
import Projects from "./Pages/Projects";
import About from "./Pages/About";
import Home from "./Pages/Home";
import { useRef } from "react";
import ScrollToTop from "./Component/ScrollToTop";

import GitHubCal from "./Component/GithubCalender";

function App() {

  const pagesRef=useRef({})
  console.log(pagesRef)
  return (
    <div className="App">
    <Box position= {["sticky","sticky","sticky","sticky"]} top="0px" zIndex={99}>
      <Navbar pagesRef={pagesRef} />
    </Box>
      <VStack  spacing={{base:"10px",lg:"60px"}}w={{base:"95%",lg:"75%"}} m="auto">
        {/* <AllRoute /> */}
        <Box  ref={(element) => pagesRef.current["Home"] = element}/>
        <Home />
        <Box ref={(element) => pagesRef.current["About"] = element}/>
        <About />
        <Box ref={(element) => pagesRef.current["Skills"] = element}/>
        <Skills />
        
      <Box ref={(element) => pagesRef.current["Projects"] = element}/>
        <Projects/>
        <GitHubCal/>
        <Box ref={(element) => pagesRef.current["Contact"] = element}/>
        <Contact />
        <Box ref={(element) => pagesRef.current["Footer"] = element}/>
        <Footer />
      </VStack>
     
      <ScrollToTop/>
    </div>
  );
}

export default App;
